import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M20 17H4V5h8V3H2v16h6v2h8v-2h6v-5h-2z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "m17 14 5-5-1.41-1.41L18 10.17V3h-2v7.17l-2.59-2.58L12 9z"
}, "1")], 'InstallDesktopSharp');